import { createStore, storeKey } from 'vuex'
import utils from '../../../shared/utils'
const vuex = createStore({
    state: {
        game: {
            user: null,
            session: null,
            role: utils.USER_ROLES.GUEST,
            state: utils.GAME_STATES.IDLE,
            current_question: null,
            users: [],
            questions: [],
            logos: [],
            question: null,
            clients: [],
            handshakes: [],
            styles: utils.GAME_STYLES,
            images: utils.GAME_IMAGES,
            seasons: [],
            stages: [],
            season_users: [],
            rankings: [],
            sectors: [],
            active_ranking: null,
            feedback_stats: null,
            paused_sector_name: null,
            paused_sector_id: null,
            active_season_id: null,
        },
        logo:0,
        fullscreen: false,
        current_choice: "",
        current_view: "",
        loading: true,
        network: null,
        game_settings: false,
        // Online mode's identity, entirely separate from `game` (which gets
        // wholesale-replaced by setGame on every websocket CLIENT_UPDATE -
        // nesting this in there would make it vulnerable to being clobbered
        // by an unrelated event-mode broadcast reaching this tab's socket).
        // See client.js's client_update() online-mode gate for the other
        // half of that isolation.
        online_user: null,
        // The online player's own most recent POST /api/answers result
        // ({correct, score}) - StageActivity.vue watches this to drive its
        // feedback banner without waiting on a refetch.
        last_online_answer: null,
        // Event-mode GUEST join gate (see JoinByCode.vue / VALIDATE_JOIN_CODE).
        // Top-level, not under `game` - `setGame` wholesale-replaces `game` on
        // every CLIENT_JOIN/CLIENT_AUTH, which would otherwise wipe these.
        join_verified: false,
        join_code_result: null,
        // Auth.vue's step1 (name)/step2 (jersey) request/response signals -
        // same top-level, outside-of-`game` reasoning as join_code_result
        // above, and for the same reason (CLIENT_AUTH's own success path
        // wholesale-replaces `game` via setGame).
        username_check_result: null,
        client_auth_result: null,
        // ONLINE mode's equivalent of join_verified above - carries a
        // scanned season code across the Login/Register navigation gap
        // (see JoinSeason.vue) so a fresh login/registration can auto-enroll
        // into that season instead of landing on the flat MySeasons picker.
        // Persisted the same way online_session is, since that gap can
        // survive a hard refresh (e.g. bookmarking /register mid-flow).
        pending_join_season_code: null,
    },
    getters: {
    },
    mutations: {
        setUser(state, params){
            state.game.user = params;
        },
        setSession(state, params){
            state.game.session = params;
            if(state.game.session != null) {
                localStorage.setItem("session", state.game.session);
                sessionStorage.setItem("event_session", state.game.session);
            } else {
                localStorage.removeItem("session");
                sessionStorage.removeItem("event_session");
            }
        },
        setCurrentChoice(state, params){
            state.current_choice = params;
        },
        setCurrentView(state, params){
            state.current_view = params;
        },
        setGameSettings(state, params){
            state.game_settings = params;
        },
        setRole(state, params){
            state.game.user.role = params;
        },
        setFullScreen(state, params){
            state.fullscreen = params;
        },
        setState(state, params){
            state.game.state = params;
        },
        setLogos(state, params){
            state.game.logos = params;
        },
        setLogo(state, params){
            state.logo = params;
        },
        setCurrentQuestion(state, params){
            state.game.current_question = params;
        },
        setUsers(state, params){
            state.game.users = params;
        },
        setQuestions(state, params){
            state.game.questions = params;
        },
        setQuestion(state, params){
            state.game.question = params;
        },
        // Mirrors setUsers - StageActivity.vue seeds this with a single
        // "self" entry so the reused type/*.vue components' own
        // user_activity()-style lookups (already-answered detection,
        // selected-choice pre-fill) keep working unmodified in online mode.
        setClients(state, params){
            state.game.clients = params;
        },
        setOnlineUser(state, params){
            state.online_user = params;
            if(params && params.session)
                localStorage.setItem("online_session", params.session);
        },
        clearOnlineAuth(state){
            state.online_user = null;
            localStorage.removeItem("online_session");
        },
        setPendingJoinSeasonCode(state, params){
            state.pending_join_season_code = params;
            if(params)
                localStorage.setItem("pending_join_season_code", params);
            else
                localStorage.removeItem("pending_join_season_code");
        },
        setLastOnlineAnswer(state, params){
            state.last_online_answer = params;
        },
        setHandshakes(state, params){
            state.game.handshakes = params;
        },
        setJoinVerified(state, params){
            state.join_verified = params;
        },
        setJoinCodeResult(state, params){
            state.join_code_result = params;
        },
        setUsernameCheckResult(state, params){
            state.username_check_result = params;
        },
        setClientAuthResult(state, params){
            state.client_auth_result = params;
        },
        setGame(state, params){
            state.game = params;
            if (window.MODE === utils.APP_MODES.EVENT)
                state.join_verified = !!params.user?.season_id;
            if(params.user)
                this.commit("setSession", params.user.session);
        },
        setLoading(state, params){
            state.loading = params;
        },
        setNetwork(state, params){
            state.network = params;
        },
        loadLocalStorage(state, params){
            var session = sessionStorage.getItem("event_session") || localStorage.getItem("session");
            if(session != null)
                state.game.session = session;

            var pending_join_season_code = localStorage.getItem("pending_join_season_code");
            if(pending_join_season_code != null)
                state.pending_join_season_code = pending_join_season_code;
        }
    },
    actions: {
    },
    modules: {
    }
})

export default vuex;